import uuid from '../../../services/uuid';
import cacheService from '../../../services/cacheService';
import submitCommand from '../../../services/submitCommand';

export const clonePathway = (trainingId: string, newName: string, orgId?: string, initiatingUserId?: string) => {
  const id = uuid.generate();
  const cmd = { id: id, fromId: trainingId, newName: newName, ownerId: orgId, initiatingUserId };
  cacheService.removeAllInPath('/v1/workflows');

  return submitCommand(id, cmd, 'CopyWorkflow', 'WorkflowNameChanged', [
    'WorkflowFailedToClone',
    'WorkflowNameDuplicateError',
  ]);
};
